import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from './ui/PageLayout';
import AddUserPage from './AddUserPage';

/**
 * Standalone Add User page with Sidebar + PageLayout.
 * Renders AddUserPage with isDialog={false} for full-page invite flow.
 */
const AddUserPageWrapper = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/settings/team-organization');
  };

  const handleInviteSubmit = () => {
    navigate('/settings/team-organization');
  };

  return (
    <PageLayout>
      <AddUserPage
        isDialog={false}
        onClose={handleClose}
        onInviteSubmit={handleInviteSubmit}
      />
    </PageLayout>
  );
};

export default AddUserPageWrapper;
